export default __webpack_public_path__ + "static/media/about.e7af426b.jpg";